import { formatDate } from '../../utils/globalHelpers';

export const createNotification = ({
  date,
  lastUpdated,
  name,
  text,
}) => ({
  content: [{
    inlineBlocks: [{
      style: [],
      text,
      type: 'span',
    }],
    type: 'paragraph',
  }],
  date,
  lastUpdated,
  name,
});

export const createNotificationWithLink = ({
  date,
  lastUpdated,
  name,
  text,
  url,
}) => ({
  content: [{
    inlineBlocks: [
      {
        data: { url },
        text,
        type: 'link',
      },
    ],
    type: 'paragraph',
  }],
  date,
  lastUpdated,
  name,
});

export const createUnreadMessageNotifications = ({
  name,
  path,
  text,
  unreadMessages,
}) => unreadMessages.flatMap(({ unreadReplyDates }) =>
  Array.from({ length: unreadReplyDates.length }, (_, i) => createNotificationWithLink(
    {
      date: formatDate(unreadReplyDates[i], null, 'MMMM D, YYYY'),
      lastUpdated: unreadReplyDates[i],
      name,
      text,
      url: path,
    },
  )));

export const formatIntlNotifications = ({ intl, notifications }) => {
  const formatMessage = (message) => {
    if (intl.messages[message]) {
      return intl.formatMessage({ id: message });
    }
    return message;
  };

  return notifications.map(({ content, ...restProps }) => {
    const formattedContent = content.map(({ inlineBlocks, ...restContent }) => {
      const formattedInlineBlocks = inlineBlocks.map(({ text, ...restInlineBlock }) => ({
        text: formatMessage(text),
        ...restInlineBlock,
      }));
      return {
        inlineBlocks: formattedInlineBlocks,
        ...restContent,
      };
    });

    return {
      content: formattedContent,
      ...restProps,
    };
  });
};
